import React, { useState } from "react";
import AnimatedLogo from "./elements/AnimatedLogo";
import ArrowIcon from "./elements/ArrowIcon";

function Footer() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="row app-footer">
      <div className="col-12">
        <footer className="text-center pt-4 pt-md-5">
          <div className={`${isHovered ? "gap-1 bg-yellow pb-0 p-1" : "gap-2 bg-white p-2"} d-flex justify-content-center align-items-center mx-auto rounded-pill`}
            style={{ width: "fit-content", border: "2px solid #2b3034", overflow: "hidden", cursor: "pointer" }}
            onMouseEnter={() => setIsHovered(true)}
            onClick={() => window.open("https://phong.info", "_blank", "noopener,noreferrer")}
          >
            <AnimatedLogo
              alt="QR Cook"
              width={isHovered ? 117 : 60}
              height={isHovered ? 117 : 60}
              shouldPlay={isHovered}
              border={isHovered ? "none" : undefined}
              borderRadius={isHovered ? "0%" : undefined}
            />
            <div className={isHovered ? "pe-4" : "pe-3"}>
              <p className={isHovered ? "mb-1" : "mb-0"}>
                &copy; {new Date().getFullYear()} by{" "}
                <a href="mailto:phong.msit@gmail.com" className="fw-bold text-decoration-none hyperlink" onClick={(e) => e.stopPropagation()}>
                  phong.msit
                </a>
              </p>
              <div className="d-flex align-items-center text-decoration-none fw-bold hyperlink" style={{ fontSize: "18px", color: isHovered ? "#2b3034" : "#e76e2a" }}>
                <ArrowIcon width={18} height={18} className="me-1" /> See Author Page
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default Footer;
